import {
  Box,
  BoxProps,
  Card,
  Flex,
  Heading,
  Text,
  VStack,
} from '@chakra-ui/react'

import { Icon } from '../components/Icons/Icon'
import { SaveIcon } from '../components/Icons/SaveIcon'
import { useAppStore } from '../store/appStore/appStore'
import { colors } from '../theme/colors'

export const TextPlaceHolder = (props: BoxProps) => (
  <Box rounded="34px" {...props} />
)

export const Title = () => {
  const userName = useAppStore(store => store.auth.user!.name)
  return (
    <Flex direction="column" alignItems="center">
      <Box textAlign="center">
        <Heading
          color="#FFFFFF"
          fontSize="28px"
          fontWeight="600"
          letterSpacing="0.84px"
          lineHeight="120%"
          mb="16px"
        >
          Welcome, {userName}
        </Heading>
        <Text
          fontSize="16px"
          color="#FFFFFF"
          fontWeight="500"
          letterSpacing="0.84px"
          lineHeight="120%"
          mb="8px"
          w="fit-content"
          mx="auto"
        >
          Supply chain data you can trust
        </Text>
      </Box>
    </Flex>
  )
}

export const Dial = () => (
  <svg
    width="346"
    height="337"
    viewBox="0 0 346 337"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M345 171.938C345 128.178 327.616 86.2091 296.673 55.2656C265.729 24.3221 223.761 6.93824 180 6.93823C136.239 6.93823 94.2709 24.3221 63.3274 55.2656C32.3839 86.2091 15 128.177 15 171.938L82.7842 171.938C82.7842 146.155 93.0266 121.428 111.258 103.196C129.49 84.9648 154.217 74.7225 180 74.7225C205.783 74.7225 230.51 84.9648 248.742 103.196C266.973 121.428 277.216 146.155 277.216 171.938H345Z"
      fill="url(#paint0_angular_1127_2153)"
    />
    <g filter="url(#filter0_d_1127_2153)">
      <path
        d="M263.5 46.9383L184 153.438L178 154.438L175 149.438L263.5 46.9383Z"
        fill="#7EACA7"
      />
    </g>
    <rect x="17" y="192.154" width="215" height="16" rx="8" fill="#7EACA7" />
    <rect x="253" y="192.154" width="75" height="16" rx="8" fill="#7EACA7" />
    <rect
      x="335.397"
      y="77.2437"
      width="20"
      height="9"
      rx="4.5"
      transform="rotate(60 335.397 77.2437)"
      fill="#7EACA7"
    />
    <rect
      x="236.466"
      width="20"
      height="9"
      rx="4.5"
      transform="rotate(23.1106 236.466 0)"
      fill="#7EACA7"
    />
    <rect
      x="17.0132"
      y="87.4612"
      width="20"
      height="9"
      rx="4.5"
      transform="rotate(-60 17.0132 87.4612)"
      fill="#7EACA7"
    />
    <rect
      y="179.154"
      width="20"
      height="9"
      rx="4.5"
      transform="rotate(-90 0 179.154)"
      fill="#7EACA7"
    />
    <rect x="169" y="163.154" width="20" height="9" rx="4.5" fill="#7EACA7" />
    <defs>
      <filter
        id="filter0_d_1127_2153"
        x="165"
        y="40.9382"
        width="108.5"
        height="127.5"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1127_2153"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1127_2153"
          result="shape"
        />
      </filter>
      <radialGradient
        id="paint0_angular_1127_2153"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(180.75 193.438) rotate(-166.183) scale(142.369)"
      >
        <stop offset="0.108718" stopColor="#FF5C65" />
        <stop offset="0.19997" stopColor="#FD9982" />
        <stop offset="0.316366" stopColor="#F8C268" />
        <stop offset="0.40177" stopColor="#6CCE81" />
        <stop offset="0.996162" stopColor="#BC2970" />
      </radialGradient>
    </defs>
  </svg>
)

export const GradientUnderLay = () => (
  <Box
    position="fixed"
    bgGradient="linear(to-t, #020202, #ffffff00)"
    height="15%"
    left="0"
    right="0"
    bottom="0"
  />
)

export const SectionCardTitle = ({ children }) => (
  <Text as="h2" fontSize="24px" color="#FFFFFF" fontWeight="400">
    {children}
  </Text>
)

export const CardInfo = () => {
  return (
    <Card
      borderWidth="1px"
      borderRadius="24px"
      border="2px solid rgba(255, 255, 255, 0.25)"
      bg="transparent"
      height="214px"
    >
      <VStack gap="19px" p="42px">
        <SaveIcon color="presets.turquoise.10" boxSize="44px" />
        <Text
          color="presets.neutral.0"
          fontSize="16px"
          fontWeight="500"
          opacity="0.7"
          textAlign="center"
          maxWidth="738px"
          mx="auto"
          noOfLines={3}
        >
          You currently have no saved views. To create and save a view, open a
          link from the View My section on the left side menu, customize the
          tables and filters as needed, then click the Save icon.
        </Text>
      </VStack>
    </Card>
  )
}

export const Bars = () => (
  <svg
    width="289"
    height="152"
    viewBox="0 0 289 152"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="21" width="37" height="131" rx="8" fill="#ECFBF8" />
    <rect x="42" y="88" width="37" height="64" rx="8" fill="#ECFBF8" />
    <rect x="84" y="63" width="37" height="89" rx="8" fill="#ECFBF8" />
    <rect x="126" y="38" width="37" height="114" rx="8" fill="#ECFBF8" />
    <rect
      x="168"
      width="37"
      height="152"
      rx="8"
      fill={colors.presets.turquoise[30]}
    />
    <rect x="210" y="22" width="37" height="130" rx="8" fill="#ECFBF8" />
    <rect x="252" y="80" width="37" height="72" rx="8" fill="#ECFBF8" />
  </svg>
)
export const Chart = () => (
  <svg
    width="319"
    height="149"
    viewBox="0 0 319 149"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M315 3.99988C315 3.99988 295.06 65.6872 280.013 65.6872C264.965 65.6872 265.974 83.3122 252.8 83.3122C239.626 83.3122 243.952 22.7571 237.25 30.4157C225.93 43.3506 223.593 92.174 213.925 83.3122C204.257 74.4503 195 39.2004 190.6 48.0623C186.2 56.9241 190.484 61.281 175.05 61.281C159.616 61.281 160.988 86.1952 155.613 100.937C150.237 115.679 130.745 48.0623 120.625 48.0623C110.505 48.0623 94.1817 136.187 85.6375 136.187C77.0933 136.187 77.1722 127.375 70.0875 127.375C63.0028 127.375 60.7592 118.562 50.65 118.562C40.5407 118.562 34.8103 140.582 27.325 140.582C19.8397 140.582 4 145 4 145H315V3.99988Z"
      fill="url(#paint0_linear_1381_10067)"
    />
    <path
      d="M315 3.99988C315 3.99988 295.06 65.6872 280.012 65.6872C264.965 65.6872 265.974 83.3122 252.8 83.3122C239.626 83.3122 243.952 22.7571 237.25 30.4157C225.93 43.3506 223.593 92.174 213.925 83.3122C204.257 74.4503 195 39.2004 190.6 48.0623C186.2 56.9241 190.484 61.281 175.05 61.281C159.616 61.281 160.988 86.1952 155.612 100.937C150.237 115.679 130.745 48.0623 120.625 48.0623C110.505 48.0623 94.1817 136.187 85.6375 136.187C77.0933 136.187 77.1722 127.375 70.0875 127.375C63.0028 127.375 60.7593 118.562 50.65 118.562C40.5407 118.562 34.8103 140.582 27.325 140.582C19.8397 140.582 4 145 4 145"
      stroke="#E2BB4E"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1381_10067"
        x1="314.338"
        y1="145"
        x2="314.338"
        y2="4.60001"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FBDB82" stopOpacity="0" />
        <stop offset="1" stopColor="#FBDB82" />
      </linearGradient>
    </defs>
  </svg>
)

export const PieChart = () => (
  <svg
    width="285"
    height="166"
    viewBox="0 0 285 166"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="212.204"
      y="48.4746"
      width="72.6102"
      height="7.83051"
      rx="3.91525"
      fill="white"
      fillOpacity="0.24"
    />
    <rect
      x="212.204"
      y="66.9829"
      width="72.6102"
      height="7.83051"
      rx="3.91525"
      fill="white"
      fillOpacity="0.24"
    />
    <rect
      x="212.204"
      y="89.0508"
      width="72.6102"
      height="7.83051"
      rx="3.91525"
      fill="white"
      fillOpacity="0.24"
    />
    <rect
      x="212.204"
      y="109.695"
      width="72.6102"
      height="7.83051"
      rx="3.91525"
      fill="white"
      fillOpacity="0.24"
    />
    <g filter="url(#filter0_dd_1381_9929)">
      <circle cx="193.339" cy="51.6777" r="6.76271" fill="#875FFF" />
    </g>
    <g filter="url(#filter1_dd_1381_9929)">
      <circle cx="193.339" cy="72.3218" r="6.76271" fill="#7146F3" />
    </g>
    <g filter="url(#filter2_dd_1381_9929)">
      <circle cx="193.339" cy="93.6777" r="6.76271" fill="#5930D7" />
    </g>
    <g filter="url(#filter3_dd_1381_9929)">
      <circle cx="193.339" cy="115.034" r="6.76271" fill="#1B0759" />
    </g>
    <path
      d="M146 82.9997C146 69.428 141.617 56.2191 133.504 45.3392C125.391 34.4593 113.982 26.4902 100.974 22.6182"
      stroke="#1B0759"
      strokeWidth="40"
    />
    <path
      d="M141.376 106.69C144.471 99.0633 146.042 90.9045 145.999 82.6743"
      stroke="#5930D7"
      strokeWidth="40"
    />
    <path
      d="M127.548 127.547C134.874 120.221 140.28 111.201 143.288 101.286"
      stroke="#5930D7"
      strokeWidth="40"
    />
    <path
      d="M83 146C91.2733 146 99.4655 144.371 107.109 141.205C114.753 138.038 121.698 133.398 127.548 127.548"
      stroke="#875FFF"
      strokeWidth="40"
    />
    <path
      d="M38.4521 127.548C50.2669 139.363 66.2912 146 82.9999 146"
      stroke="#875FFF"
      strokeWidth="40"
    />
    <path
      d="M25.0156 107.634C28.309 115.386 33.1234 122.399 39.174 128.258"
      stroke="#7146F3"
      strokeWidth="40"
    />
    <path
      d="M45.0013 32.7495C33.5316 41.4228 25.3742 53.7588 21.8839 67.7086C18.3937 81.6585 19.7807 96.3825 25.8146 109.435"
      stroke="#7146F3"
      strokeWidth="40"
    />
    <path
      d="M104.205 23.6758C94.025 20.0372 83.0801 19.0793 72.423 20.8943C61.7658 22.7093 51.755 27.2361 43.3535 34.0394"
      stroke="#1B0759"
      strokeWidth="40"
    />
    <defs>
      <filter
        id="filter0_dd_1381_9929"
        x="183.576"
        y="42.915"
        width="19.5254"
        height="19.5254"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1381_9929"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1381_9929"
          result="effect2_dropShadow_1381_9929"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_1381_9929"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_dd_1381_9929"
        x="183.576"
        y="63.5591"
        width="19.5254"
        height="19.5254"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1381_9929"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1381_9929"
          result="effect2_dropShadow_1381_9929"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_1381_9929"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_dd_1381_9929"
        x="183.576"
        y="84.915"
        width="19.5254"
        height="19.5254"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1381_9929"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1381_9929"
          result="effect2_dropShadow_1381_9929"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_1381_9929"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_dd_1381_9929"
        x="183.576"
        y="106.271"
        width="19.5254"
        height="19.5254"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1381_9929"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1381_9929"
          result="effect2_dropShadow_1381_9929"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_1381_9929"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
export const VBar = () => (
  <svg
    width="335"
    height="53"
    viewBox="0 0 335 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 53C7.16344 53 4.65945e-08 45.8366 1.04072e-07 37L2.40666e-07 16C2.98143e-07 7.16344 7.16344 1.56609e-07 16 3.49796e-07L47 1.02753e-06L47 53L16 53Z"
      fill="#6E1E39"
    />
    <path d="M47 53L47 0L83 9.27814e-08L83 53L47 53Z" fill="#C4556C" />
    <path d="M83 53L83 0L216 3.42776e-07L216 53L83 53Z" fill="#B93F5F" />
    <path
      d="M320 53C328.284 53 335 46.2843 335 38L335 15C335 6.71573 328.284 -1.73082e-08 320 -3.86589e-08L216 -3.06694e-07L216 53L320 53Z"
      fill="#B7225C"
    />
  </svg>
)

const componentMap = {
  Bars,
  Chart,
  PieChart,
  VBar,
}

export const ChartCard = ({ iconName, graphName }) => {
  const SelectedComponent = componentMap[graphName]
  return (
    <Card
      borderRadius="34px"
      border="1px solid"
      backgroundColor="rgba(255, 255, 255, 0.13)"
      minH="211px"
      position="relative"
      overflow="hidden"
      direction="row"
      flex="1"
      _dark={{
        borderColor: 'transparent',
        _hover: {
          borderColor: 'presets.turquoise.50',
        },
      }}
    >
      <VStack
        backgroundColor="rgba(255, 255, 255, 0.13)"
        alignItems="baseline"
        width="36%"
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          bg="presets.turquoise.10"
          borderRadius="full"
          boxSize="44px"
          ml="24px"
          mt="26px"
          mb="25px"
          flexShrink={0}
        >
          <Icon icon={iconName} boxSize="20px" color="presets.turquoise.100" />
        </Box>

        <Box
          width="66px"
          height="16px"
          backgroundColor="rgba(255, 255, 255, 0.45)"
          borderRadius="34px"
        ></Box>
        <Box
          width="102px"
          height="11px"
          backgroundColor="rgba(255, 255, 255, 0.45)"
          borderRadius="34px"
        ></Box>
      </VStack>
      <Flex
        alignItems="center"
        width="64%"
        justifyContent="space-between"
        backgroundColor="rgba(255, 255, 255, 0.13)"
        padding="20px"
      >
        <Box
          width="100%"
          height="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <SelectedComponent />
        </Box>
      </Flex>
    </Card>
  )
}
